export const MAX_CAMERA_LIMIT = 10;
export const REALTIME_CONNECTION_TIMEOUT_VALUE = 200;
export const SCREEN_SHARE_REQUEST_STATUS = {
  IDLE: 'idle',
  REQUESTED: 'requested',
  ACCEPTED: 'accepted',
  DENIED: 'denied',
  ACTIVE: 'active'
};
